import { render, staticRenderFns } from "./FormQuestions.vue?vue&type=template&id=318a3284&"
import script from "./FormQuestions.vue?vue&type=script&lang=js&"
export * from "./FormQuestions.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports